module.exports = __webpack_public_path__ + "static/map_vertical_ua-2859894b9715e26fb831d709cb193ed2.png";